import {
  FileItem,
  FileUploadService,
  FileUploadServiceProvider,
  QuestionData,
  SectionData,
} from '@playbooks/action-cards-utils/src'

import useFomService from '../hooks/useFomService'
import { useAppContext } from '../contexts/AppContext'

export class ProjectFileUploadServiceProvider implements FileUploadServiceProvider {
  public getService(_question: QuestionData): FileUploadService {
    const {
      settings: { playId },
    } = useAppContext()
    return new ProjectFileUploadService(playId || '')
  }
}

class ProjectFileUploadService implements FileUploadService {
  private fomService = useFomService()

  private projectId?: number | string

  public get isDisabled() {
    return !this.projectId
  }

  constructor(projectId?: number | string) {
    this.projectId = projectId
  }

  public async deleteFile(file: FileItem): Promise<void> {
    await this.fomService.deleteProjectFile(file.id)
  }

  public async uploadFiles(uploadingFiles: File[], currentHeader: SectionData): Promise<FileItem[]> {
    const uploadPromises = []
    const newFileItems: FileItem[] = []
    for (let i = 0; i < uploadingFiles.length; i++) {
      const file = uploadingFiles[i]
      uploadPromises.push(
        this.fomService
          .uploadProjectFile(this.projectId!, currentHeader.id, currentHeader.name, file)
          .then(([id, url]) => {
            newFileItems.push({ id, name: file.name, url })
          })
          .catch(error => {
            newFileItems.push({ id: 0, name: file.name, error: error.message })
          }),
      )
    }

    await Promise.all(uploadPromises)
    return newFileItems
  }
}
